import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { needsRefresh } from '@/utils/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderName',
  props: {
    params: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'sale-order', params: { saleOrderId: _ctx.params.data.id }, query: { refresh: _unref(needsRefresh)(_ctx.params.data.pricingStatus)?.toString(), name: _ctx.params.data.orderName } },
    class: "text-primary underline cursor-pointer",
    rel: "noopener",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.params.value), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})